import { FC, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import MainLayout from 'components/main-layout/MainLayout';
import LayoutContent from 'components/main-layout/LayoutContent';
import TabNavigation from 'components/TabNavigation';
import { usePermissionsContext } from 'store/permissions';

interface IProps {
  isLoading?: boolean;
  error?: unknown;
  children: React.ReactNode;
}

const InnerWrapper: FC<IProps> = ({ children, isLoading, error }) => {
  const { permissions } = usePermissionsContext();
  const { t } = useTranslation();
  const configureTabs = () => {
    const tabItems = [
      {
        to: '/reports/usage',
        label: 'Справка брой потребители',
      },
    ];
    return tabItems;
  };

  const [tabs, setTabs] = useState(configureTabs());

  useEffect(() => {
    setTabs(configureTabs());
  }, [permissions]);
  return (
    <MainLayout title={t('reports.title')}>
      <TabNavigation tabs={tabs} />
      <LayoutContent
        isLoading={isLoading}
        error={error}
      >
        {children}
      </LayoutContent>
    </MainLayout>
  );
};

export default InnerWrapper;
